export default __webpack_public_path__ + "static/media/immobilienvermittlung.c0fcf456.png";